var map = {
	"./README.md": "6nuA",
	"./deck": "1C3/",
	"./deck.mdx": "1C3/",
	"./images/Create_Order_Saga.png": "ASwh",
	"./images/Slim events require more communication.drawio.png": "j78B",
	"./images/Sync service.drawio.png": "kThO",
	"./images/control-system.png": "dxLi",
	"./images/event-driven-queue.png": "pUI8",
	"./images/event-driven.png": "nHwf",
	"./images/events-must-flow.jpg": "UkqK",
	"./images/mf.jpg": "qiOE",
	"./images/monolith.png": "p1Pa",
	"./images/request-driven-error.png": "YD8T",
	"./images/request-driven.png": "bmOq",
	"./images/service-boundary-1.png": "T1vg",
	"./images/service-boundary-2.png": "i5zQ",
	"./images/service-boundary-3.png": "I2NF",
	"./images/service-boundary-4.png": "vF9b",
	"./images/service-boundary-5.png": "Sxkz",
	"./images/sql.png": "7WSl",
	"./images/tweet_651897353889259520_20240424_113650_via_10015_io.png": "FmcZ",
	"./main.css": "O5Ip",
	"./mf.jpg": "vS5f",
	"./package": "9RND",
	"./package.json": "9RND",
	"./sql.png": "4HM6",
	"./src/Layout": "ATjy",
	"./src/Layout.tsx": "ATjy",
	"./src/LocalImage": "Nfkd",
	"./src/LocalImage.tsx": "Nfkd",
	"./static/_headers": "6uyA",
	"./static/_redirects": "bL9x",
	"./yarn.lock": "Id5S"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Xqc";